import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-edit-communication-setup-dialog',
  templateUrl: './edit-communication-setup-dialog.component.html',
  styleUrls: ['./communication-setup.component.css']
})
export class EditCommunicationSetupDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<EditCommunicationSetupDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
  }

  onClose(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    this.dialogRef.close({ action: 'save', model: this.data.model });
  }

}
